import { render, staticRenderFns } from "./AssistantDetail.vue?vue&type=template&id=a08ad63a&"
import script from "./AssistantDetail.vue?vue&type=script&lang=js&"
export * from "./AssistantDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssistantDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports